import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetProvincesInput, ProvinceInput, ProvinceResult, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class ProvinceService {

  constructor(private httpClient: HttpClient) { }

  public addProvince(provinceInput: ProvinceInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Province/AddProvince', provinceInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editProvince(id: number, provinceInput: ProvinceInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'Province/EditProvince?id=' + id, provinceInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteProvince(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'Province/DeleteProvince?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getProvinces(getProvincesInput: GetProvincesInput, token: string): Promise<ResultList<ProvinceResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Province/GetProvinces', getProvincesInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ProvinceResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ProvinceResult>(), result.error));
  }
}
